import React, { useState } from "react";
import { MdOutlineSearch } from "react-icons/md";
import { ReactSVG } from "react-svg";
import { data, NavLink } from "react-router-dom";
import LOPLink from "./LOPLink";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { HiClipboardDocumentList } from "react-icons/hi2";
import { FiX } from "react-icons/fi";

const Societies = ({
  color,
  banner,
  societies,
  name,
  error,
  isLoading,
  isFetching,
  search,
  setSearch,
  page,
  setPage,
  currentPage,
  totalPages,
  societyStatus,
  totalSocieties,
}) => {
  const getBgColor = (status) => {
    if (status === "approved") return "bg-[#DEE9E4]";
    if (status === "unapproved") return "bg-[#DDEBF7]";
    return "bg-[#F1D1CE]";
  };
  const [viewFile, setViewFile] = useState(null);

  const handlePrev = () => {
    if (page > 1) setPage((prev) => prev - 1);
  };

  const handleNext = () => {
    if (page < totalPages) setPage((prev) => prev + 1);
  };

  const start = totalSocieties > 0 ? (page - 1) * 12 + 1 : 0;
  let end = page * 12;
  if (end > totalSocieties) end = totalSocieties;

  return (
    <div className="xl:px-[5%] lg:px-[3%] px-[2%]  flex flex-col md:gap-10 gap-5">
      <div className="flex justify-center  lg:py-6 py-4  relative ">
        <img className="w-full rounded-2xl" src={banner} alt="" />
        <div className=" absolute lg:bottom-10 md:bottom-8 bottom-6  text-white lg:left-10 md:left-8 sm:left-6 left-4 z-10">
          <div
            style={{ backgroundColor: color }}
            className=" xl:py-2 lg:py-[6px] md:px-5 sm:px-3 px-2 xl:text-[1.2rem] lg:text-[1rem] md:text-[.9rem] sm:text-[.8rem] text-[.7rem] xl:rounded-2xl lg:rounded-xl md:rounded-lg rounded-md font-semibold w-max"
          >
            Rawalpindi Development Authority
          </div>
          <div className=" xl:text-[4rem] lg:text-[3rem] md:text-[2.5rem] sm:text-[1.8rem] text-[1.2rem] font-bold">
            {name}
          </div>
        </div>
      </div>
      <div className=" px-3 flex flex-col justify-center items-center gap-4">
        <h1 className="xl:text-[2.5rem] lg:text-[1.8rem] text-[1.6rem]  font-bold text-center">
          Beware of Frauds/Scams of Private Housing Societies
        </h1>
        <p className="xl:text-[1.2rem] md:text-[1rem] text-[.9rem] text-[#7A7A7A] text-center">
          Public at large is advised to refrain from making any investment in
          illegal/fake/unapproved housing societies. Further, updated
          information of authenticity & sanctity of societies approved by PHATA
          should be obtained from PHATA directly. Moreover, never rely on fake
          screenshots of this page circulated on social media and always check
          status of private housing societies by visiting this web page in real
          time.
        </p>
      </div>
      <div className="flex flex-col items-center">
        <div className="flex justify-center items-center sm:gap-3 gap-2 bg-white sm:p-3 p-2 rounded-xl">
          <div className="flex justify-center items-center sm:gap-3 gap-2 bg-[#F6F6F6] sm:p-3 p-2 text-[#CDCDCD] rounded-xl">
            <MdOutlineSearch className="size-8" />
            <input
              type="text"
              className=" outline-none bg-transparent md:w-[20rem] sm:w-[15rem] w-[12rem]"
              placeholder="Search by scheme, location or other"
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setPage(1);
              }}
            />
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-4 mb-16 xl:w-[90%] w-[96%] mx-auto">
        <span className="text-[1.5rem] font-semibold">Results</span>
        <div className=" flex justify-between items-center">
          <div className=" text-[#0000004f]">
            Showing record {start} to {end} of {totalSocieties}
          </div>
          <div style={{ color: color }} className=" flex items-center gap-4">
            <div
              onClick={handlePrev}
              disabled={page === 1}
              className={`${getBgColor(societyStatus)} p-2  rounded-xl ${
                page === 1 ? " cursor-not-allowed opacity-50" : "cursor-pointer"
              }`}
            >
              <IoIosArrowBack className="size-6" />
            </div>
            {currentPage}
            <div
              onClick={handleNext}
              disabled={page === totalPages}
              className={`${getBgColor(societyStatus)} p-2  rounded-xl ${
                page === totalPages
                  ? " cursor-not-allowed opacity-50"
                  : "cursor-pointer"
              }`}
            >
              <IoIosArrowForward className="size-6" />
            </div>
          </div>
        </div>
        {isLoading || isFetching ? (
          <div className="grid md:grid-cols-2 lg:gap-6 gap-4">
            <div className=" bg-[#EFEFEF] animate-pulse aspect-[2/.6] rounded-xl"></div>
            <div className=" bg-[#EFEFEF] animate-pulse aspect-[2/.6] rounded-xl"></div>
            <div className=" bg-[#EFEFEF] animate-pulse aspect-[2/.6] rounded-xl"></div>
            <div className=" bg-[#EFEFEF] animate-pulse aspect-[2/.6] rounded-xl"></div>
            <div className=" bg-[#EFEFEF] animate-pulse aspect-[2/.6] rounded-xl"></div>
            <div className=" bg-[#EFEFEF] animate-pulse aspect-[2/.6] rounded-xl"></div>
            <div className=" bg-[#EFEFEF] animate-pulse aspect-[2/.6] rounded-xl"></div>
            <div className=" bg-[#EFEFEF] animate-pulse aspect-[2/.6] rounded-xl"></div>
            <div className=" bg-[#EFEFEF] animate-pulse aspect-[2/.6] rounded-xl"></div>
            <div className=" bg-[#EFEFEF] animate-pulse aspect-[2/.6] rounded-xl"></div>
            <div className=" bg-[#EFEFEF] animate-pulse aspect-[2/.6] rounded-xl"></div>
            <div className=" bg-[#EFEFEF] animate-pulse aspect-[2/.6] rounded-xl"></div>
          </div>
        ) : (
          data && (
            <>
              {totalPages === 0 ? (
                <div
                  style={{ color: color }}
                  className=" text-center w-full lg:text-[3rem] md:text-[2rem] text-[1.4rem] font-semibold "
                >
                  No society Found
                </div>
              ) : (
                <div className="grid md:grid-cols-2 lg:gap-6 gap-4">
                  {societies?.map((society, i) => (
                    <div
                      key={i}
                      className={`flex  w-full lg:p-4 p-3 lg:rounded-3xl rounded-xl ${getBgColor(
                        society?.status,
                      )}`}
                    >
                      <div className="flex-1 flex flex-col gap-1 lg:text-[1rem] text-[.9rem] items-start  ">
                        <h1 className=" font-semibold lg:text-[1.5rem] text-[1.3rem]">
                          {society?.name}
                        </h1>{" "}
                        <div className="text-[#5F5F5F]">
                          <span className="font-bold">Location: </span>{" "}
                          <span className="font-medium">
                            {society?.location}
                          </span>
                        </div>
                        <div className="text-[#5F5F5F]">
                          <span className="font-bold">Current Status: </span>{" "}
                          <span className="font-medium capitalize">
                            {society?.statusDescription
                              ? society?.statusDescription
                              : society?.status}
                          </span>
                        </div>
                        {society?.map?.mapUrl && (
                          <div
                            className="flex  gap-3 font-semibold "
                            style={{ color: color }}
                          >
                            <ReactSVG
                              src={"/icon/location.svg"}
                              className={`w-3.5 fill-current `}
                            />
                            <span className={`flex underline `}>
                              <LOPLink
                                mapUrl={society.map.mapUrl}
                                status={society.status}
                              />
                              {society.map.mapUrl &&
                                society?.mortagedPlotsLink && <span> / </span>}
                              {society?.mortagedPlotsLink && (
                                <NavLink
                                  to={society?.mortagedPlotsLink}
                                  target="_blank"
                                >
                                  Mortaged Plots
                                </NavLink>
                              )}
                            </span>
                          </div>
                        )}
                        {society?.onePager?.docUrl && (
                          <button
                            type="button"
                            onClick={() =>
                              setViewFile({
                                url: society?.onePager?.docUrl,
                                mimeType: society?.onePager?.fileType,
                              })
                            }
                            className={`flex  gap-3 underline font-semibold items-center `}
                            style={{ color: color }}
                          >
                            <HiClipboardDocumentList className=" size-4" />
                            One Pager
                          </button>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </>
          )
        )}
        {error && (
          <p className=" text-red-500 text-center md:text-[1rem] text-sm bg-red-100 p-2 rounded-lg">
            {error?.data?.message || error?.data?.error}
          </p>
        )}
      </div>

      {viewFile && (
        <div className="fixed inset-0 bg-black bg-opacity-10 backdrop-blur-sm flex items-center justify-center z-[200]">
          <div className="relative bg-white/80 border border-white/30 backdrop-blur-lg rounded-2xl shadow-xl p-4  w-[90%] h-[95vh]  animate-fade-in text-black">
            <button
              onClick={(e) => {
                e.stopPropagation();
                setViewFile(null);
              }}
              className="absolute top-4 right-4 text-[#00643b]"
              aria-label="Close modal"
            >
              <FiX className="size-6" />
            </button>
            <h2 className="text-[1.5rem] font-bold lg:mb-4 mb-3 text-[#00643b]">
              One Pager Doc
            </h2>
            {viewFile.mimeType === "application/pdf" ? (
              <iframe
                src={viewFile.url}
                width="100%"
                height="90%"
                className="rounded-[1rem] mt-2"
                title="PDF Preview"
              />
            ) : viewFile.mimeType.startsWith("image/") ? (
              <img
                src={viewFile.url}
                alt="file Preview"
                className="rounded-[1rem] mt-2 w-full h-[90%]  object-contain"
              />
            ) : (
              <p className="text-red-500 mt-4  text-center">
                This file type cannot be previewed.
              </p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Societies;
